import { useEffect, useState } from "react";
import {
  addToWishlist,
  removeFromWishlist,
  isInWishlist,
} from "../services/wishlist";
import { useAuthUser } from "../hooks/useAuthUser";

function WishlistButton({ movie }) {
  const user = useAuthUser();
  const [added, setAdded] = useState(false);

  useEffect(() => {
    if (!user?.id || !movie?.id) return;

    isInWishlist(user.id, movie.id).then(setAdded);
  }, [user, movie]);

  const toggleWishlist = async (e) => {
    e.stopPropagation();
    if (!user?.id) return;

    if (added) {
      await removeFromWishlist(user.id, movie.id);
      setAdded(false);
      window.dispatchEvent(new Event("wishlist-updated"));
    } else {
      await addToWishlist(user.id, movie);
      setAdded(true);
      window.dispatchEvent(new Event("wishlist-updated"));
    }
  };

  return (
    <button
      className={`wishlist-btn ${added ? "active" : ""}`}
      onClick={toggleWishlist}
      aria-label="wishlist"
    >
      {added ? "❤️" : "🤍"}
    </button>
  );
}

export default WishlistButton;
